import { formatNumber } from '../../core/formatter/formatNumber';
import { IDs } from '../../helpers/IDs';
import { i18n } from '../../i18n/i18n';
import * as React from 'react';
import { SectionStyle } from '../../helpers/SectionStyle';
// import { WHelpIcon } from '../../core/elements/WHelpIcon';
import { WpdfText } from '../datenauswertung/pdf/WpdfText.';
import { WpdfView } from '../datenauswertung/pdf/WpdfView';

interface ZusatztoolsSteuerEnergieProps extends React.ClassAttributes<any> {
    data: any;
    isPdf?: boolean;
    jahr: number;
}

export class ZusatztoolsSteuerEnergie extends React.Component<ZusatztoolsSteuerEnergieProps, {}> {

    constructor(props: any) {
        super(props);
        this.state = {};
    }

    getStyle(): any {
        const isPdf: boolean = this.props.isPdf || false;

        const Section: any = new SectionStyle();
        const headerBgColor = Section.getPropertyValue('--color-main-section-datenauswertung');
        const rowBgColor = Section.getPropertyValue('--color-breadcrumb-background');

        return ({
            main: {
                display: 'flex',
                flexDirection: 'column'
            },
            ueberschrift: {
                ...(isPdf && { fontFamily: 'Helvetica-Bold' }),
                fontSize: '11pt',
                fontWeight: 'bold',
                maxWidth: 650,
                margin: '20px 20px 0 0',
                display: 'flex',
                flex: 1,
                flexDirection: 'row',
                boxSizing: 'border-box'
            },
            hinweis: {
                fontSize: '9pt',
                maxWidth: 650,
                margin: '15px 20px 0 0',
                display: 'flex',
                flex: 1,
                flexDirection: 'row',
                boxSizing: 'border-box'
            },
            tabelle: {
                fontSize: '9pt',
                maxWidth: 650,
                margin: '15px 20px 0 0',
                border: '1pt solid white',
                display: 'flex',
                flex: 0,
                flexDirection: 'column',
                boxSizing: 'border-box'
            },
            row: {
                backgroundColor: rowBgColor,
                display: 'flex',
                flex: 1,
                flexDirection: 'row',
                boxSizing: 'border-box'
            },
            row_header: {
                ...(isPdf && { fontFamily: 'Helvetica-Bold' }),
                fontWeight: 'bold',
                color: 'white',
                backgroundColor: headerBgColor
            },
            row_spacertop: {
                marginTop: 6
            },
            row_spacertop2: {
                marginTop: 12
            },
            row_spacertop3: {
                marginTop: 18
            },
            colgroup: {
                ...(!isPdf && { minHeight: 27 }),
                display: 'flex',
                flex: 1,
                flexDirection: 'column'
            },
            colgroup_header: {
            },
            col1: {
                flexBasis: '78%'
            },
            col1_header: {
                flexBasis: '78%',
                flexDirection: 'row'
            },
            col2: {
                flexBasis: '10%'
            },
            col2_header: {
                flexBasis: '10%'
            },
            col3: {
                flexBasis: '2%'
            },
            col3_header: {
                flexBasis: '2%'
            },
            cell: {
                textAlign: 'left',
                padding: isPdf ? 2 : 4,
                ...(isPdf && { paddingTop: 4, paddingBottom: 4 }),
                borderTop: '1pt solid white',
                borderLeft: '1pt solid white',
                display: 'flex',
                flex: 1,
                justifyContent: 'flex-start',
                ...(!isPdf && { alignItems: 'center' }),
                boxSizing: 'border-box'
            },
            cell_header: {
            },
            cell_bold: {
                ...(isPdf && { fontFamily: 'Helvetica-Bold' }),
                fontWeight: 'bold'
            },
            cell_borderbottom: {
                borderBottom: '1pt solid #555'
            },
            cell_italic: {
                ...(isPdf && { fontFamily: 'Helvetica-Bold' }),
                fontStyle: 'italic'
            },
            cell_nobgcolor: {
                backgroundColor: 'white'
            },
            cell_nospacerbottom: {
                paddingBottom: 0,
                borderTop: isPdf ? '4pt solid white' : '6pt solid white'
            },
            cell_right: {
                textAlign: 'right',
                justifyContent: 'flex-end'
            },
            cell_stromsteuer: {
                backgroundColor: 'white',
                paddingBottom: 0,
                borderTop: isPdf ? '4pt solid white' : '6pt solid white'
            },
            cell1: {
            },
            cell2: {
                textAlign: 'right',
                justifyContent: 'flex-end'
            },
            cell2_header: {
                textAlign: 'right',
                borderLeft: 'none',
                justifyContent: 'flex-end'
            },
            cell3: {
                borderLeft: 'none'
            },
            cell3_header: {
                textAlign: 'right',
                borderLeft: 'none',
                justifyContent: 'flex-end'
            },
            cell4: {
                borderLeft: 'none'
            }
        });
    }

    render(): JSX.Element {
        if (!this.props.jahr) {
            return null;
        }
        const isPdf: boolean = this.props.isPdf || false;
        const styles: any = this.getStyle();

        return (
            <WpdfView style={styles.main} pdf={isPdf}>
                {this.renderUeberschrift()}
                {this.renderTabelle()}
            </WpdfView>
        );
    }

    renderTabelle(): JSX.Element {
        const data: any = (this.props.data[IDs.STEUER_ENERGIE] || {})[this.props.jahr] || {};
        const isPdf: boolean = this.props.isPdf || false;
        const styles: any = this.getStyle();
        let summe = data.erstattung || 0;
        summe += ((this.props.data[IDs.STEUER_STROM] || {})[this.props.jahr] || {}).erstattung || 0;
        // console.log('Steuer Energie', data);
        if (!(data.hasParameter || false)) {
            return (
                <WpdfView style={styles.hinweis} pdf={isPdf}>
                    <WpdfText pdf={isPdf}>
                        {i18n('Es konnten keine Parameter für das Jahr {{1}} gefunden werden, bitte kontaktieren Sie Ihren Ansprechpartner:in', 'sys').replace('{{1}}', this.props.jahr)}
                    </WpdfText>
                </WpdfView>
            );
        }

        // const helpStyle: React.CSSProperties = { width: 18, height: 18, borderRadius: 10, backgroundColor: 'var(--color-main-section-datenauswertung)', verticalAlign: 'top', margin: 0 };
        // const helpIconErdgas = (
        //     <WHelpIcon
        //         data={this.props.data}
        //         styleDivProps={{ display: 'inline-block' }}
        //         styleProps={helpStyle}
        //         label='Hinweise Erdgas'
        //         helpKey='steuer_hinweise_erdgas'
        //         type='info'
        //         editBar
        //     />
        // );
        // const helpIconHEL: JSX.Element = (
        //     <WHelpIcon
        //         data={this.props.data}
        //         styleDivProps={{ display: 'inline-block' }}
        //         styleProps={helpStyle}
        //         label='Hinweise HEL'
        //         helpKey='steuer_hinweise_hel'
        //         type='info'
        //         editBar
        //     />
        // );
        // const helpIconFluessiggas: JSX.Element = (
        //     <WHelpIcon
        //         data={this.props.data}
        //         styleDivProps={{ display: 'inline-block' }}
        //         styleProps={helpStyle}
        //         label='Hinweise Flüssiggas'
        //         helpKey='steuer_hinweise_fluessiggas'
        //         type='info'
        //         editBar
        //     />
        // );

        return (
            <WpdfView style={styles.tabelle} pdf={isPdf}>
                <WpdfView style={{ ...styles.row, ...styles.row_header }} pdf={isPdf}>
                    <WpdfView style={{ ...styles.colgroup, ...styles.colgroup_header, ...styles.col1_header }} pdf={isPdf}>
                        <WpdfView style={{ ...styles.cell, ...styles.cell_header, ...styles.cell1_header }} pdf={isPdf}>
                            <WpdfText pdf={isPdf}>{i18n('Berechnung Energiesteuer', 'sys')}</WpdfText>
                        </WpdfView>
                        <WpdfView style={{ ...styles.cell, ...styles.cell_header, ...styles.cell2_header }} pdf={isPdf}>
                            <WpdfText pdf={isPdf}>{i18n('Jahr', 'sys')}:</WpdfText>
                        </WpdfView>
                    </WpdfView>
                    <WpdfView style={{ ...styles.colgroup, ...styles.colgroup_header, ...styles.col2_header }} pdf={isPdf}>
                        <WpdfView style={{ ...styles.cell, ...styles.cell_header, ...styles.cell3_header }} pdf={isPdf}>
                            <WpdfText pdf={isPdf}>{this.props.jahr}</WpdfText>
                        </WpdfView>
                    </WpdfView>
                    <WpdfView style={{ ...styles.colgroup, ...styles.colgroup_header, ...styles.col3_header }} pdf={isPdf}>
                        <WpdfView style={{ ...styles.cell, ...styles.cell_header, ...styles.cell4 }} pdf={isPdf}>
                            <WpdfText pdf={isPdf}></WpdfText>
                        </WpdfView>
                    </WpdfView>
                </WpdfView>
                {/* ======> ERDGAS <====== */}
                <WpdfView style={{ ...styles.row, ...styles.row_spacertop }} pdf={isPdf}>
                    <WpdfView style={{ ...styles.colgroup, ...styles.col1 }} pdf={isPdf}>
                        <WpdfView style={{ ...styles.cell, ...styles.cell1, display: 'flex', flexDirection: 'row' }} pdf={isPdf}>
                            <WpdfText pdf={isPdf} style={{ ...styles.cell_bold, display: 'inline', width: 70 }}>{i18n('Erdgas', 'sys')}:</WpdfText>
                            <WpdfText pdf={isPdf} style={{ display: 'inline' }}>{i18n('Verbrauch gemäß Rechnung(en)', 'sys')}</WpdfText>
                        </WpdfView>
                    </WpdfView>
                    <WpdfView style={{ ...styles.colgroup, ...styles.col2 }} pdf={isPdf}>
                        <WpdfView style={{ ...styles.cell, ...styles.cell2 }} pdf={isPdf}>
                            <WpdfText pdf={isPdf}>{formatNumber(data.verbrauch_erdgas || 0, 2)}</WpdfText>
                        </WpdfView>
                    </WpdfView>
                    <WpdfView style={{ ...styles.colgroup, ...styles.col3 }} pdf={isPdf}>
                        <WpdfView style={{ ...styles.cell, ...styles.cell3 }} pdf={isPdf}>
                            <WpdfText pdf={isPdf}>kWh</WpdfText>
                        </WpdfView>
                    </WpdfView>
                </WpdfView>
                {data.weitergeleitete_waermemenge_erdgas_kwh > 0 &&
                    <WpdfView style={{ ...styles.row }} pdf={isPdf}>
                        <WpdfView style={{ ...styles.colgroup, ...styles.col1 }} pdf={isPdf}>
                            <WpdfView style={{ ...styles.cell, ...styles.cell1, display: 'flex', flexDirection: 'row' }} pdf={isPdf}>
                                <WpdfText pdf={isPdf} style={{ display: 'inline', width: 70 }}></WpdfText>
                                <WpdfText pdf={isPdf} style={{ display: 'inline' }}>{i18n('Weitergeleitete Wärmemenge', 'sys')}</WpdfText>
                            </WpdfView>
                        </WpdfView>
                        <WpdfView style={{ ...styles.colgroup, ...styles.col2 }} pdf={isPdf}>
                            <WpdfView style={{ ...styles.cell, ...styles.cell2 }} pdf={isPdf}>
                                <WpdfText pdf={isPdf}>-{formatNumber(data.weitergeleitete_waermemenge_erdgas_kwh || 0, 2)}</WpdfText>
                            </WpdfView>
                        </WpdfView>
                        <WpdfView style={{ ...styles.colgroup, ...styles.col3 }} pdf={isPdf}>
                            <WpdfView style={{ ...styles.cell, ...styles.cell3 }} pdf={isPdf}>
                                <WpdfText pdf={isPdf}>kWh</WpdfText>
                            </WpdfView>
                        </WpdfView>
                    </WpdfView>
                }
                {data.weitergeleitete_waermemenge_erdgas_kwh > 0 &&
                    <WpdfView style={{ ...styles.row }} pdf={isPdf}>
                        <WpdfView style={{ ...styles.colgroup, ...styles.col1 }} pdf={isPdf}>
                            <WpdfView style={{ ...styles.cell, ...styles.cell1, display: 'flex', flexDirection: 'row' }} pdf={isPdf}>
                                <WpdfText pdf={isPdf} style={{ display: 'inline', width: 70 }}></WpdfText>
                                <WpdfText pdf={isPdf} style={{ display: 'inline' }}>{i18n('Im Betrieb genutzte Wärmemenge', 'sys')}</WpdfText>
                            </WpdfView>
                        </WpdfView>
                        <WpdfView style={{ ...styles.colgroup, ...styles.col2 }} pdf={isPdf}>
                            <WpdfView style={{ ...styles.cell, ...styles.cell2 }} pdf={isPdf}>
                                <WpdfText pdf={isPdf}>{formatNumber(data.verbrauch_genutzte_erdgas || 0, 2)}</WpdfText>
                            </WpdfView>
                        </WpdfView>
                        <WpdfView style={{ ...styles.colgroup, ...styles.col3 }} pdf={isPdf}>
                            <WpdfView style={{ ...styles.cell, ...styles.cell3 }} pdf={isPdf}>
                                <WpdfText pdf={isPdf}>kWh</WpdfText>
                            </WpdfView>
                        </WpdfView>
                    </WpdfView>
                }
                <WpdfView style={{ ...styles.row }} pdf={isPdf}>
                    <WpdfView style={{ ...styles.colgroup, ...styles.col1 }} pdf={isPdf}>
                        <WpdfView style={{ ...styles.cell, ...styles.cell1, display: 'flex', flexDirection: 'row' }} pdf={isPdf}>
                            <WpdfText pdf={isPdf} style={{ display: 'inline', width: 70 }}></WpdfText>
                            <WpdfText pdf={isPdf} style={{ ...styles.cell_bold, display: 'inline' }}>
                                {i18n('Entlastungsbetrag', 'sys')} ({formatNumber(data.steuersatz_erdgas_erm || 0, 2)} €/MWh)
                            </WpdfText>
                        </WpdfView>
                    </WpdfView>
                    <WpdfView style={{ ...styles.colgroup, ...styles.col2 }} pdf={isPdf}>
                        <WpdfView style={{ ...styles.cell, ...styles.cell2, ...styles.cell_bold }} pdf={isPdf}>
                            <WpdfText pdf={isPdf}>{formatNumber(data.entlastung_erdgas || 0, 2)}</WpdfText>
                        </WpdfView>
                    </WpdfView>
                    <WpdfView style={{ ...styles.colgroup, ...styles.col3 }} pdf={isPdf}>
                        <WpdfView style={{ ...styles.cell, ...styles.cell3, ...styles.cell_bold }} pdf={isPdf}>
                            <WpdfText pdf={isPdf}>€</WpdfText>
                        </WpdfView>
                    </WpdfView>
                </WpdfView>
                {/* ======> HEL <====== */}
                <WpdfView style={{ ...styles.row, ...styles.row_spacertop }} pdf={isPdf}>
                    <WpdfView style={{ ...styles.colgroup, ...styles.col1 }} pdf={isPdf}>
                        <WpdfView style={{ ...styles.cell, ...styles.cell1, display: 'flex', flexDirection: 'row' }} pdf={isPdf}>
                            <WpdfText pdf={isPdf} style={{ ...styles.cell_bold, display: 'inline', width: 70 }}>{i18n('Heizöl', 'sys')}:</WpdfText>
                            <WpdfText pdf={isPdf} style={{ display: 'inline' }}>{i18n('Verbrauch gemäß Rechnung(en)', 'sys')}</WpdfText>
                        </WpdfView>
                    </WpdfView>
                    <WpdfView style={{ ...styles.colgroup, ...styles.col2 }} pdf={isPdf}>
                        <WpdfView style={{ ...styles.cell, ...styles.cell2 }} pdf={isPdf}>
                            <WpdfText pdf={isPdf}>{formatNumber(data.verbrauch_hel || 0, 2)}</WpdfText>
                        </WpdfView>
                    </WpdfView>
                    <WpdfView style={{ ...styles.colgroup, ...styles.col3 }} pdf={isPdf}>
                        <WpdfView style={{ ...styles.cell, ...styles.cell3 }} pdf={isPdf}>
                            <WpdfText pdf={isPdf}>kWh</WpdfText>
                        </WpdfView>
                    </WpdfView>
                </WpdfView>
                {data.weitergeleitete_waermemenge_hel_kwh > 0 &&
                    <WpdfView style={{ ...styles.row }} pdf={isPdf}>
                        <WpdfView style={{ ...styles.colgroup, ...styles.col1 }} pdf={isPdf}>
                            <WpdfView style={{ ...styles.cell, ...styles.cell1, display: 'flex', flexDirection: 'row' }} pdf={isPdf}>
                                <WpdfText pdf={isPdf} style={{ display: 'inline', width: 70 }}></WpdfText>
                                <WpdfText pdf={isPdf} style={{ display: 'inline' }}>{i18n('Weitergeleitete Wärmemenge', 'sys')}</WpdfText>
                            </WpdfView>
                        </WpdfView>
                        <WpdfView style={{ ...styles.colgroup, ...styles.col2 }} pdf={isPdf}>
                            <WpdfView style={{ ...styles.cell, ...styles.cell2 }} pdf={isPdf}>
                                <WpdfText pdf={isPdf}>-{formatNumber(data.weitergeleitete_waermemenge_hel_kwh || 0, 2)}</WpdfText>
                            </WpdfView>
                        </WpdfView>
                        <WpdfView style={{ ...styles.colgroup, ...styles.col3 }} pdf={isPdf}>
                            <WpdfView style={{ ...styles.cell, ...styles.cell3 }} pdf={isPdf}>
                                <WpdfText pdf={isPdf}>kWh</WpdfText>
                            </WpdfView>
                        </WpdfView>
                    </WpdfView>
                }
                {data.weitergeleitete_waermemenge_hel_kwh > 0 &&
                    <WpdfView style={{ ...styles.row }} pdf={isPdf}>
                        <WpdfView style={{ ...styles.colgroup, ...styles.col1 }} pdf={isPdf}>
                            <WpdfView style={{ ...styles.cell, ...styles.cell1, display: 'flex', flexDirection: 'row' }} pdf={isPdf}>
                                <WpdfText pdf={isPdf} style={{ display: 'inline', width: 70 }}></WpdfText>
                                <WpdfText pdf={isPdf} style={{ display: 'inline' }}>{i18n('Im Betrieb genutzte Wärmemenge', 'sys')}</WpdfText>
                            </WpdfView>
                        </WpdfView>
                        <WpdfView style={{ ...styles.colgroup, ...styles.col2 }} pdf={isPdf}>
                            <WpdfView style={{ ...styles.cell, ...styles.cell2 }} pdf={isPdf}>
                                <WpdfText pdf={isPdf}>{formatNumber(data.verbrauch_genutzte_hel || 0, 2)}</WpdfText>
                            </WpdfView>
                        </WpdfView>
                        <WpdfView style={{ ...styles.colgroup, ...styles.col3 }} pdf={isPdf}>
                            <WpdfView style={{ ...styles.cell, ...styles.cell3 }} pdf={isPdf}>
                                <WpdfText pdf={isPdf}>kWh</WpdfText>
                            </WpdfView>
                        </WpdfView>
                    </WpdfView>
                }
                <WpdfView style={{ ...styles.row }} pdf={isPdf}>
                    <WpdfView style={{ ...styles.colgroup, ...styles.col1 }} pdf={isPdf}>
                        <WpdfView style={{ ...styles.cell, ...styles.cell1, display: 'flex', flexDirection: 'row' }} pdf={isPdf}>
                            <WpdfText pdf={isPdf} style={{ display: 'inline', width: 70 }}>
                                {isPdf ? '' : ''/*helpIconHEL*/}
                            </WpdfText>
                            <WpdfText pdf={isPdf} style={{ ...styles.cell_bold, display: 'inline' }}>
                                {i18n('Entlastungsbetrag', 'sys')} ({formatNumber(data.steuersatz_hel_erm || 0, 2)} €/1.000 l)
                            </WpdfText>
                        </WpdfView>
                    </WpdfView>
                    <WpdfView style={{ ...styles.colgroup, ...styles.col2 }} pdf={isPdf}>
                        <WpdfView style={{ ...styles.cell, ...styles.cell2, ...styles.cell_bold }} pdf={isPdf}>
                            <WpdfText pdf={isPdf}>{formatNumber(data.entlastung_hel || 0, 2)}</WpdfText>
                        </WpdfView>
                    </WpdfView>
                    <WpdfView style={{ ...styles.colgroup, ...styles.col3 }} pdf={isPdf}>
                        <WpdfView style={{ ...styles.cell, ...styles.cell3, ...styles.cell_bold }} pdf={isPdf}>
                            <WpdfText pdf={isPdf}>€</WpdfText>
                        </WpdfView>
                    </WpdfView>
                </WpdfView>
                {/* ======> Flüssiggas <====== */}
                <WpdfView style={{ ...styles.row, ...styles.row_spacertop }} pdf={isPdf}>
                    <WpdfView style={{ ...styles.colgroup, ...styles.col1 }} pdf={isPdf}>
                        <WpdfView style={{ ...styles.cell, ...styles.cell1, display: 'flex', flexDirection: 'row' }} pdf={isPdf}>
                            <WpdfText pdf={isPdf} style={{ ...styles.cell_bold, display: 'inline', width: 70 }}>{i18n('Flüssiggas', 'sys')}:</WpdfText>
                            <WpdfText pdf={isPdf} style={{ display: 'inline' }}>{i18n('Verbrauch gemäß Rechnung(en)', 'sys')}</WpdfText>
                        </WpdfView>
                    </WpdfView>
                    <WpdfView style={{ ...styles.colgroup, ...styles.col2 }} pdf={isPdf}>
                        <WpdfView style={{ ...styles.cell, ...styles.cell2 }} pdf={isPdf}>
                            <WpdfText pdf={isPdf}>{formatNumber(data.verbrauch_fluessiggas || 0, 2)}</WpdfText>
                        </WpdfView>
                    </WpdfView>
                    <WpdfView style={{ ...styles.colgroup, ...styles.col3 }} pdf={isPdf}>
                        <WpdfView style={{ ...styles.cell, ...styles.cell3 }} pdf={isPdf}>
                            <WpdfText pdf={isPdf}>kWh</WpdfText>
                        </WpdfView>
                    </WpdfView>
                </WpdfView>
                {data.weitergeleitete_waermemenge_fluessiggas_kwh > 0 &&
                    <WpdfView style={{ ...styles.row }} pdf={isPdf}>
                        <WpdfView style={{ ...styles.colgroup, ...styles.col1 }} pdf={isPdf}>
                            <WpdfView style={{ ...styles.cell, ...styles.cell1, display: 'flex', flexDirection: 'row' }} pdf={isPdf}>
                                <WpdfText pdf={isPdf} style={{ display: 'inline', width: 70 }}></WpdfText>
                                <WpdfText pdf={isPdf} style={{ display: 'inline' }}>{i18n('Weitergeleitete Wärmemenge', 'sys')}</WpdfText>
                            </WpdfView>
                        </WpdfView>
                        <WpdfView style={{ ...styles.colgroup, ...styles.col2 }} pdf={isPdf}>
                            <WpdfView style={{ ...styles.cell, ...styles.cell2 }} pdf={isPdf}>
                                <WpdfText pdf={isPdf}>-{formatNumber(data.weitergeleitete_waermemenge_fluessiggas_kwh || 0, 2)}</WpdfText>
                            </WpdfView>
                        </WpdfView>
                        <WpdfView style={{ ...styles.colgroup, ...styles.col3 }} pdf={isPdf}>
                            <WpdfView style={{ ...styles.cell, ...styles.cell3 }} pdf={isPdf}>
                                <WpdfText pdf={isPdf}>kWh</WpdfText>
                            </WpdfView>
                        </WpdfView>
                    </WpdfView>
                }
                {data.weitergeleitete_waermemenge_fluessiggas_kwh > 0 &&
                    <WpdfView style={{ ...styles.row }} pdf={isPdf}>
                        <WpdfView style={{ ...styles.colgroup, ...styles.col1 }} pdf={isPdf}>
                            <WpdfView style={{ ...styles.cell, ...styles.cell1, display: 'flex', flexDirection: 'row' }} pdf={isPdf}>
                                <WpdfText pdf={isPdf} style={{ display: 'inline', width: 70 }}></WpdfText>
                                <WpdfText pdf={isPdf} style={{ display: 'inline' }}>{i18n('Im Betrieb genutzte Wärmemenge', 'sys')}</WpdfText>
                            </WpdfView>
                        </WpdfView>
                        <WpdfView style={{ ...styles.colgroup, ...styles.col2 }} pdf={isPdf}>
                            <WpdfView style={{ ...styles.cell, ...styles.cell2 }} pdf={isPdf}>
                                <WpdfText pdf={isPdf}>{formatNumber(data.verbrauch_genutzte_fluessiggas || 0, 2)}</WpdfText>
                            </WpdfView>
                        </WpdfView>
                        <WpdfView style={{ ...styles.colgroup, ...styles.col3 }} pdf={isPdf}>
                            <WpdfView style={{ ...styles.cell, ...styles.cell3 }} pdf={isPdf}>
                                <WpdfText pdf={isPdf}>kWh</WpdfText>
                            </WpdfView>
                        </WpdfView>
                    </WpdfView>
                }
                <WpdfView style={{ ...styles.row }} pdf={isPdf}>
                    <WpdfView style={{ ...styles.colgroup, ...styles.col1 }} pdf={isPdf}>
                        <WpdfView style={{ ...styles.cell, ...styles.cell1, display: 'flex', flexDirection: 'row' }} pdf={isPdf}>
                            <WpdfText pdf={isPdf} style={{ display: 'inline', width: 70 }}>
                                {isPdf ? '' : ''/*helpIconFluessiggas*/}
                            </WpdfText>
                            <WpdfText pdf={isPdf} style={{ ...styles.cell_bold, display: 'inline' }}>
                                {i18n('Entlastungsbetrag', 'sys')} ({formatNumber(data.steuersatz_fluessiggas_erm || 0, 2)} €/1.000 kg)
                            </WpdfText>
                        </WpdfView>
                    </WpdfView>
                    <WpdfView style={{ ...styles.colgroup, ...styles.col2 }} pdf={isPdf}>
                        <WpdfView style={{ ...styles.cell, ...styles.cell2, ...styles.cell_bold }} pdf={isPdf}>
                            <WpdfText pdf={isPdf}>{formatNumber(data.entlastung_fluessiggas || 0, 2)}</WpdfText>
                        </WpdfView>
                    </WpdfView>
                    <WpdfView style={{ ...styles.colgroup, ...styles.col3 }} pdf={isPdf}>
                        <WpdfView style={{ ...styles.cell, ...styles.cell3, ...styles.cell_bold }} pdf={isPdf}>
                            <WpdfText pdf={isPdf}>€</WpdfText>
                        </WpdfView>
                    </WpdfView>
                </WpdfView>
                {/* ======> SELBSTBEHALT und ERGEBNIS <====== */}
                <WpdfView style={{ ...styles.row }} pdf={isPdf}>
                    <WpdfView style={{ ...styles.colgroup, ...styles.col1 }} pdf={isPdf}>
                        <WpdfView
                            style={{ ...styles.cell, ...styles.cell1, ...styles.cell_right, ...styles.cell_stromsteuer }}
                            pdf={isPdf}
                        >
                            <WpdfText pdf={isPdf}>{i18n('abzüglich Sockelbetrag nach § 54 Abs.3 EnergieStG', 'sys')}</WpdfText>
                        </WpdfView>
                    </WpdfView>
                    <WpdfView style={{ ...styles.colgroup, ...styles.col2 }} pdf={isPdf}>
                        <WpdfView style={{ ...styles.cell, ...styles.cell2, ...styles.cell_stromsteuer }} pdf={isPdf}>
                            <WpdfText pdf={isPdf}>-{formatNumber(data.selbstbehalt || 0, 2)}</WpdfText>
                        </WpdfView>
                    </WpdfView>
                    <WpdfView style={{ ...styles.colgroup, ...styles.col3 }} pdf={isPdf}>
                        <WpdfView style={{ ...styles.cell, ...styles.cell3, ...styles.cell_stromsteuer }} pdf={isPdf}>
                            <WpdfText pdf={isPdf}>€</WpdfText>
                        </WpdfView>
                    </WpdfView>
                </WpdfView>
                <WpdfView style={{ ...styles.row }} pdf={isPdf}>
                    <WpdfView style={{ ...styles.colgroup, ...styles.col1 }} pdf={isPdf}>
                        <WpdfView
                            style={{ ...styles.cell, ...styles.cell1, ...styles.cell_right, ...styles.cell_bold, ...styles.cell_nobgcolor }}
                            pdf={isPdf}
                        >
                            <WpdfText pdf={isPdf}>{i18n('Vom Hauptzollamt zu erstattender Betrag', 'sys')}</WpdfText>
                        </WpdfView>
                    </WpdfView>
                    <WpdfView style={{ ...styles.colgroup, ...styles.col2 }} pdf={isPdf}>
                        <WpdfView style={{ ...styles.cell, ...styles.cell2, ...styles.cell_bold }} pdf={isPdf}>
                            <WpdfText pdf={isPdf}>{formatNumber(data.erstattung || 0, 2)}</WpdfText>
                        </WpdfView>
                    </WpdfView>
                    <WpdfView style={{ ...styles.colgroup, ...styles.col3 }} pdf={isPdf}>
                        <WpdfView style={{ ...styles.cell, ...styles.cell3 }} pdf={isPdf}>
                            <WpdfText pdf={isPdf}>€</WpdfText>
                        </WpdfView>
                    </WpdfView>
                </WpdfView>
                <WpdfView style={{ ...styles.row, ...styles.row_header, ...styles.row_spacertop3 }} pdf={isPdf}>
                    <WpdfView style={{ ...styles.colgroup, ...styles.colgroup_header, ...styles.col1_header }} pdf={isPdf}>
                        <WpdfView style={{ ...styles.cell, ...styles.cell_header, ...styles.cell1_header }} pdf={isPdf}>
                            <WpdfText pdf={isPdf}>{i18n('Berechnung Strom & Energiesteuer', 'sys')}</WpdfText>
                        </WpdfView>
                        <WpdfView style={{ ...styles.cell, ...styles.cell_header, ...styles.cell2_header }} pdf={isPdf}>
                            <WpdfText pdf={isPdf}>{i18n('Jahr', 'sys')}:</WpdfText>
                        </WpdfView>
                    </WpdfView>
                    <WpdfView style={{ ...styles.colgroup, ...styles.colgroup_header, ...styles.col2_header }} pdf={isPdf}>
                        <WpdfView style={{ ...styles.cell, ...styles.cell_header, ...styles.cell3_header }} pdf={isPdf}>
                            <WpdfText pdf={isPdf}>{this.props.jahr}</WpdfText>
                        </WpdfView>
                    </WpdfView>
                    <WpdfView style={{ ...styles.colgroup, ...styles.colgroup_header, ...styles.col3_header }} pdf={isPdf}>
                        <WpdfView style={{ ...styles.cell, ...styles.cell_header, ...styles.cell4 }} pdf={isPdf}>
                            <WpdfText pdf={isPdf}></WpdfText>
                        </WpdfView>
                    </WpdfView>
                </WpdfView>
                <WpdfView style={{ ...styles.row, ...styles.row_spacertop }} pdf={isPdf}>
                    <WpdfView style={{ ...styles.colgroup, ...styles.col1 }} pdf={isPdf}>
                        <WpdfView
                            style={{ ...styles.cell, ...styles.cell1, ...styles.cell_right, ...styles.cell_bold, ...styles.cell_nobgcolor }}
                            pdf={isPdf}
                        >
                            <WpdfText pdf={isPdf}>{i18n('Gesamtentlastung', 'sys')} ({i18n('Strom- und Energiesteuer', 'sys')})</WpdfText>
                        </WpdfView>
                    </WpdfView>
                    <WpdfView style={{ ...styles.colgroup, ...styles.col2 }} pdf={isPdf}>
                        <WpdfView style={{ ...styles.cell, ...styles.cell2, ...styles.cell_bold }} pdf={isPdf}>
                            <WpdfText pdf={isPdf}>{formatNumber(summe || 0, 2)}</WpdfText>
                        </WpdfView>
                    </WpdfView>
                    <WpdfView style={{ ...styles.colgroup, ...styles.col3 }} pdf={isPdf}>
                        <WpdfView style={{ ...styles.cell, ...styles.cell3 }} pdf={isPdf}>
                            <WpdfText pdf={isPdf}>€</WpdfText>
                        </WpdfView>
                    </WpdfView>
                </WpdfView>
            </WpdfView>
        );
    }

    renderUeberschrift(): JSX.Element {
        const isPdf: boolean = this.props.isPdf || false;
        const styles: any = this.getStyle();

        return (
            <WpdfView style={styles.ueberschrift} pdf={isPdf}>
                <WpdfText pdf={isPdf}>II) {i18n('Heizöle/Brenngase', 'sys')} (§ 54 EnergieStG)</WpdfText>
            </WpdfView>
        );
    }
}
